/*
 *@description: 存储相关方法
 *@author: 赖雪婷
 *@date: 2022-04-22 11:47:16
*/
const Storage = {
    setCookie(name, value, time, domain) {
        let exp = new Date();
        exp.setTime(exp.getTime() + time * 24 * 60 * 60 * 1000);
        document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";domain=" + domain + ";path=/";
    },
    getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(";");
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i].trim();
            if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
        }
        return "";
    },
    delCookie() {
        var keys = document.cookie.match(/[^ =;]+(?==)/g);
        console.log("key====", keys);
        if (keys) {
            for (var i = keys.length; i--;) {
                document.cookie = keys[i] + "=0;path=" / ";expires=" + new Date(0).toUTCString();
                document.cookie = keys[i] + "=0;path=/;domain=.etolies.com;expires=" + new Date(0).toUTCString(); // 清除当前域名下的，例如 .nihao.com
                document.cookie = keys[i] + "=0;path=/;domain=.etolies.com;expires=" + new Date(0).toUTCString(); // 清除一级域名下的或指定的，例如 .nihao.com
            }
        }
    },
    // 设置LocalStorage
    localStorageSet(name, obj) {
        if (!name || !obj) {
            console.log("name,obj：参数不能为空！");
            return;
        }
        window.localStorage.setItem(name, obj);
    },
    // 获得LocalStorage
    localStorageGet(name) {
        if (!name) {
            console.log("locDbGet(name): name参数不能为空！");
            return;
        }
        return window.localStorage.getItem(name);
    },
}

export default Storage;
